import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { SidePanel } from '@alfa-bank/newclick-composite-components/side-panel';
import cn from 'classnames';
import { useHistoryBasedNavigation } from '../../../hooks/use-history';
import { useStatusHeader } from '../hooks/use-status-header';
import { useTitle } from '../hooks/use-title';
import styles from './index.module.css';
export const WebviewSidePanelHeader = ({ children }) => {
    const statusHeader = useStatusHeader();
    const { title } = useTitle();
    useHistoryBasedNavigation();
    switch (statusHeader) {
        case 'WITHOUT_CALL_MOBILE':
            return (_jsxs(React.Fragment, { children: [_jsx(SidePanel.Header, { title: title, className: cn(styles.sidePanelHeader, styles.webview), hasCloser: false }), children] }));
        case 'ENDED_VOIP_SCREEN_OTHER_CONTACTS':
            return (_jsxs(React.Fragment, { children: [_jsx(SidePanel.Header, { className: cn(styles.sidePanelHeader, styles.webview), hasCloser: false, title: title }), children] }));
        default:
            return _jsxs(React.Fragment, { children: [" ", children, " "] });
    }
};
